import React, { useState } from 'react';
import YouTube from 'react-youtube';

const YouTubeHoverPlaye = ({ videoId }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const handleMouseEnter = () => {
        setIsPlaying(1);
    };

    const handleMouseLeave = () => {
        setIsPlaying(0);
    };

    const opts = {
        height: '720',
        width: '1200',
        playerVars: {
            autoplay: isPlaying ? 1 : 0, // Autoplay only when isPlaying is true
            //autoplay: 0
        },
    };

    /*const onReady = (event) => {
        event.target.playVideo(); // Play the video when ready
    };*/


    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <YouTube videoId={videoId} opts={opts} />
        </div>
    );
};

export default YouTubeHoverPlaye;